// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","userInfo":"Header_userInfo__Z8xMa"};